import { render, staticRenderFns } from "./Sipet.vue?vue&type=template&id=2d70f0ec&scoped=true&"
import script from "./Sipet.vue?vue&type=script&lang=js&"
export * from "./Sipet.vue?vue&type=script&lang=js&"
import style0 from "./Sipet.vue?vue&type=style&index=0&id=2d70f0ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d70f0ec",
  null
  
)

export default component.exports